import DdTextBox from '@/components/DdTextBox'
import DdDefaultButton from '@/components/DdDefaultButton'

import flowMixin from '@/mixins/flowMixins'

import { mapGetters } from 'vuex'

export default {
  name: 'HacchuEditDialog',
  mixins: [flowMixin],
  components: {
    DdTextBox,
    DdDefaultButton
  },
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    /**
     * 発注基本ID
     */
    hacchuKihonId: Number
  },
  data: () => ({
    hacchuNo: ''
  }),
  created () {
  },
  mounted () {
    this.initialize()
  },
  computed: {
    ...mapGetters({}),
    computedProps () {
      return {
        ...this.$props,
        persistent: true
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    }
  },
  watch: {
    showDialog: function () {
      if (this.showDialog) {
        this.HttpClient
          .get(`/api/v1/TrHacchuKihon/find?id=${this.hacchuKihonId}`)
          .then((data) => {
            this.rec = data.payload
            this.hacchuNo = this.rec.hacchuNo
          })
      }
    }
  },
  methods: {
    initialize: function () {
      const opt = {
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('●hacchuEditDialog.defineHeaderPromise')
            resolve()
          })
        },
        initializeInputPromise: this.clear(),
        savedInputRestorePromise: (c) => {
          console.log('●hacchuEditDialog.savedInputRestorePromise', c)
          return new Promise(resolve => {
            resolve()
          })
        },
        researchPromise: (c) => {
          console.log('●hacchuEditDialog.researchPromise', c)
          return new Promise(resolve => {
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('●hacchuEditDialog.restoreViewPromise', c)
          return new Promise(resolve => {
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('●hacchuEditDialog.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            resolve()
          })
        },
        getCloneTargetMethod: function () {
          return {
            rec: this.rec
          }
        }
      }
      this.initializeForViewer(opt)
    },
    clear: function () {
      console.log('clear')
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            self.hacchuNo = ''
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onCloseClick: function (e) {
      console.log('close clicked', this.showDialog)
      this.clear()
      this.$emit('close')
    }
  }
}
